import * as common from '../common/Common';
import { appService } from '../common/AppService';

export class UserProfileViewModel {
    public nickname='';
    public error = '';

    public initialize(){
        this.nickname=appService.userModel.nickname;
    }

    public submit() {
        if (!this.nickname) {
            this.error = 'Please fill all the information.';
        } else {
            common.callHttp('PUT', 'user/update', {
                Nickname: this.nickname
            }).then(() => {
                appService.userModel.nickname=this.nickname;
                appService.navigateTo('home');
            }, error => {
                this.error = error.ExceptionMessage;                
            });
        }
    }
}